import router from './router'
import store from './store'
import { getToken } from './utils/auth'
import { getInstallStatus } from './api/system'

// 缓存安装状态（admin 表是否已有记录）：首次导航检测一次，避免每次都请求
let installChecked = null

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '贞吉跑腿管理后台'

  // 从安装页离开后（如刚完成初始化），重置缓存以便重新检测安装状态
  if (from.path === '/install') {
    installChecked = null
  }

  // 首次导航检测后台是否已初始化（admin 表是否有记录）
  if (installChecked === null) {
    try {
      const res = await getInstallStatus()
      installChecked = !!(res && res.code === 0 && res.data && res.data.installed)
    } catch (e) {
      // 检测失败按"已安装"处理，避免被卡在安装页；登录流程会暴露具体错误
      console.error('[permission] 获取安装状态失败：', e)
      installChecked = true
    }
  }

  // 未初始化：强制引导到安装页（除 /install 自身外一律跳转，避免两个守卫互相重定向）
  if (!installChecked) {
    if (to.path === '/install') {
      next()
    } else {
      next('/install')
    }
    return
  }

  // 已初始化却停留在安装页 → 引导去登录
  if (to.path === '/install') {
    next('/login')
    return
  }

  // 登录页无需鉴权
  if (to.path === '/login') {
    next()
    return
  }

  const token = getToken()
  if (!token) {
    next('/login')
    return
  }

  if (!store.state.user.user) {
    store.dispatch('user/getAdminInfo').then((res) => {
      if (res && res.data) {
        store.dispatch('permission/setPermission', res.data.permissions || [])
      }
      next()
    }).catch(() => {
      next('/login')
    })
  } else {
    next()
  }
})
